import { memo } from 'react';

import { Trans, useTranslation } from '@mint-lib/i18n';
import styled from '@mint-lib/styled';
import { parse } from 'date-fns';

import { Box, Chip, StaticDateSpan, Typography } from '@myn/mui';

import { SERVER_DATE_FORMAT } from '../../../features/Co2NotificationRow/Co2NotificationRow.constnts.jsx';

type Props = {
  dateFrom: string | null;
  dateTo: string | null;
  variant?: 'default' | 'chip';
};
const DateField = memo(({ dateFrom, dateTo, variant = 'default' }: Props) => {
  const { t } = useTranslation('@myn/planning');

  const getDates = () => {
    if (!dateFrom || !dateTo) {
      return null;
    }

    return {
      dateFrom: parse(dateFrom, SERVER_DATE_FORMAT, new Date()),
      dateTo: parse(dateTo, SERVER_DATE_FORMAT, new Date()),
    };
  };

  const dates = getDates();

  if (variant === 'chip') {
    return (
      <Chip
        variant="outlined"
        size="medium"
        color="secondary"
        label={
          dates ? (
            <Trans
              i18nKey="Buying Plan duration: <DateFrom/> - <DateTo/>"
              t={t}
              components={{
                DateFrom: <StaticDateSpan date={dates.dateFrom} />,
                DateTo: <StaticDateSpan date={dates.dateTo} />,
              }}
            />
          ) : (
            `${t('Buying Plan duration')}:`
          )
        }
      />
    );
  }

  return (
    <Wrapper>
      <Typography
        variant="caption02"
        color={(theme) => theme.palette.text.secondary}
      >
        {t('Buying Plan duration')}
      </Typography>
      <Typography variant="bodyLong02">
        {dates ? (
          <>
            <StaticDateSpan date={dates.dateFrom} /> -{' '}
            <StaticDateSpan date={dates.dateTo} />
          </>
        ) : null}
      </Typography>
    </Wrapper>
  );
});

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing(0.5)};
  text-align: right;
  white-space: nowrap;
`;

export default DateField;
